export type AddressAPI = {
  address_line_1: string;
  address_line_2?: string;
  postal_code: string;
  city: string;
  region?: string;
  country: string;
};

export type Address = {
  addressLine1: string;
  addressLine2?: string;
  postalCode: string;
  city: string;
  region?: string;
  country: string;
};

export const mapAddressFromAPI = (addressAPI: AddressAPI): Address => ({
  addressLine1: addressAPI.address_line_1,
  addressLine2: addressAPI.address_line_2,
  postalCode: addressAPI.postal_code,
  city: addressAPI.city,
  region: addressAPI.region,
  country: addressAPI.country,
});

export const mapAddressToAPI = (address: Address): AddressAPI => ({
  address_line_1: address.addressLine1,
  address_line_2: address.addressLine2,
  postal_code: address.postalCode,
  city: address.city,
  region: address.region,
  country: address.country,
});
